import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import EditButton from '@/components/buttons/EditButton';
import InfoButton from '@/components/buttons/InfoButton';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const ChecksItem = ({ canEdit, nonProfitOrg }: { canEdit: boolean; nonProfitOrg: NonProfitOrgProfileResponse }) => {
  const colors = useColor();

  const isEmployeesCheck = !!nonProfitOrg.employees ? 'YES' : 'NO';
  const isVolunteersCheck = !!nonProfitOrg.volunteers ? 'YES' : 'NO';
  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.checks')}
          </Text>
          {/* // TODO: update tooltip title  */}
          <InfoButton title={i18n.t('npo_details.insights.checks')} />
        </View>
        {canEdit && (
          <EditButton
            onPress={() =>
              router.navigate({
                pathname: '/edit/npoBackgroundChecks',
                params: {
                  npoJson: JSON.stringify(nonProfitOrg)
                }
              })
            }
          />
        )}
      </View>
      <View style={styles.content}>
        <View style={styles.row}>
          <Text style={[styles.valueText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.employees')}
          </Text>
          {nonProfitOrg.employees !== null ? (
            <Text style={[styles.valueText, { color: colors.titleText }]} fontWeight="700">
              {isEmployeesCheck}
            </Text>
          ) : (
            <Text> {i18n.t('mix.n_a')}</Text>
          )}
        </View>
        <View style={styles.row}>
          <Text style={[styles.valueText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.volunteers')}
          </Text>
          {nonProfitOrg.volunteers !== null ? (
            <Text style={[styles.valueText, { color: colors.titleText }]} fontWeight="700">
              {isVolunteersCheck}
            </Text>
          ) : (
            <Text> {i18n.t('mix.n_a')}</Text>
          )}
        </View>
      </View>
      <Divider />
    </View>
  );
};

export default ChecksItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20
  },

  row: {
    flexDirection: 'row',
    marginTop: 3
  },

  valueText: {
    minWidth: 80,
    marginRight: 10,
    marginBottom: 8
  }
});
